import { useEffect, useRef, useState } from 'react'
import { api, session } from '../api.js'

// Les courriels que reçoivent les habitants. Les variables s'insèrent au
// curseur : personne n'a à retenir la syntaxe des doubles accolades.
export default function Courriels() {
  const [liste, setListe] = useState([])
  const [choisi, setChoisi] = useState(null)
  const [edition, setEdition] = useState({ subject: '', body: '' })
  const [variables, setVariables] = useState({ base: [], fields: [] })
  const [apercu, setApercu] = useState(null)
  const [message, setMessage] = useState('')
  const corps = useRef(null)
  const objet = useRef(null)
  const dernier = useRef('body')

  useEffect(() => {
    api.mails().then((m) => { setListe(m); setChoisi(m[0] || null) })
    api.mailVariables().then(setVariables)
  }, [])

  // Les champs sont contrôlés : quand on change de modèle, leur contenu suit.
  useEffect(() => {
    if (!choisi) return
    setEdition({ subject: choisi.subject, body: choisi.body })
    api.mailPreview(choisi.key).then(setApercu).catch(() => setApercu(null))
  }, [choisi?.key])   // eslint-disable-line

  if (!liste.length) return <p className="chargement">Chargement…</p>
  const lectureSeule = session.env === 'live'
  const modifie = choisi && (edition.subject !== choisi.subject || edition.body !== choisi.body)

  async function enregistrer(champs = edition) {
    const maj = { ...choisi, ...champs }
    setChoisi(maj)
    setListe(liste.map((m) => (m.key === maj.key ? maj : m)))
    await api.saveMail(maj.key, champs)
    setMessage('Enregistré. Les habitants le verront après la mise en ligne.')
    api.mailPreview(maj.key).then(setApercu)
  }

  // Insère au curseur, dans le champ où l'on écrivait en dernier.
  function inserer(variable) {
    const champ = dernier.current
    const cible = champ === 'subject' ? objet.current : corps.current
    if (!cible) return
    const debut = cible.selectionStart ?? cible.value.length
    const fin = cible.selectionEnd ?? debut
    const avant = edition[champ]
    const texte = `${avant.slice(0, debut)}{{ ${variable} }}${avant.slice(fin)}`
    setEdition({ ...edition, [champ]: texte })
    const position = debut + variable.length + 6
    setTimeout(() => { cible.focus(); cible.setSelectionRange(position, position) }, 20)
  }

  return (
    <>
      <h1>Courriels types</h1>
      <p className="chapo">Ce que reçoivent les habitants à chaque étape. Les circuits de traitement
        les envoient automatiquement.</p>
      {message && <p className="succes" role="status">{message}</p>}

      <div className="trois-col">
        <nav className="liste-laterale" aria-label="Courriels">
          {liste.map((m) => (
            <button key={m.key} className={choisi?.key === m.key ? 'on' : ''}
                    onClick={() => setChoisi(m)}>
              <strong>{m.name}</strong>
              <span>{m.used_by.length ? m.used_by.join(', ') : 'non utilisé'}</span>
            </button>
          ))}
        </nav>

        {choisi && (
          <section className="carte">
            <h2>{choisi.name}</h2>

            <div className="champ">
              <label htmlFor="obj">Objet</label>
              <input id="obj" ref={objet} value={edition.subject} disabled={lectureSeule}
                     onFocus={() => { dernier.current = 'subject' }}
                     onChange={(e) => setEdition({ ...edition, subject: e.target.value })} />
            </div>

            <div className="champ">
              <label htmlFor="corps">Message</label>
              <textarea id="corps" ref={corps} rows={14} value={edition.body} disabled={lectureSeule}
                        onFocus={() => { dernier.current = 'body' }}
                        onChange={(e) => setEdition({ ...edition, body: e.target.value })} />
            </div>

            {!lectureSeule && (
              <>
                <div className="ligne">
                  <button className="btn pri" disabled={!modifie} onClick={() => enregistrer()}>
                    {modifie ? 'Enregistrer les modifications' : 'Aucune modification'}
                  </button>
                  {modifie && (
                    <button className="btn" onClick={() => setEdition({
                      subject: choisi.subject, body: choisi.body })}>Annuler</button>
                  )}
                </div>

                <h3>Insérer une information</h3>
                <p className="aide">Cliquez pour l'ajouter là où se trouve votre curseur.</p>
                <div className="variables">
                  {variables.base.map((v) => (
                    <button key={v.var} className="jeton" title={v.var} onClick={() => inserer(v.var)}>
                      {v.label}
                    </button>
                  ))}
                </div>
                {variables.fields.length > 0 && (
                  <>
                    <h3>Réponses du formulaire</h3>
                    <div className="variables">
                      {variables.fields.slice(0, 14).map((v) => (
                        <button key={v.var} className="jeton discret" title={v.var}
                                onClick={() => inserer(v.var)}>{v.label}</button>
                      ))}
                    </div>
                  </>
                )}
              </>
            )}
          </section>
        )}

        <aside className="carte">
          <h2>Aperçu</h2>
          {modifie && <p className="aide">Enregistrez pour voir vos modifications ici.</p>}
          {apercu ? (
            <>
              <p className="aide">Rendu sur {apercu.source}.</p>
              <div className="apercu-mail">
                <p className="objet">{apercu.subject}</p>
                <pre>{apercu.body}</pre>
              </div>
            </>
          ) : <p className="aide">Aucun aperçu disponible.</p>}
        </aside>
      </div>
    </>
  )
}
